import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { AxiosError } from 'axios';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import http from '../http';

export type QueryPayload = {
    url: string;
    method: AxiosRequestConfig['method'];
    data?: AxiosRequestConfig['data'];
    params?: AxiosRequestConfig['params'];
    headers?: AxiosRequestConfig['headers'];
    errorMessage?: ((error: AxiosError) => string) | string;
    responseType?:
        | 'arraybuffer'
        | 'blob'
        | 'document'
        | 'json'
        | 'text'
        | 'stream'
        | 'formdata';
};

export type ResponsePayload = {
    status: number;
    data: unknown;
};

export type ResponseError = {
    status: number;
    message: string;
    correlationId: string | null;
};

export const axiosBaseQuery: BaseQueryFn<QueryPayload> = async (
    payload: QueryPayload
): Promise<ResponsePayload | { error: ResponseError }> => {
    return http(payload)
        .then((response: AxiosResponse): ResponsePayload => {
            return {
                status: response.status,
                data: response.data,
            };
        })
        .catch((reason: unknown): { error: ResponseError } => {
            const error: AxiosError = reason as AxiosError;
            const correlationId: string | null =
                error.response?.headers['x-correlation-id'] ??
                error.request?.headers['x-correlation-id'] ??
                null;

            if (correlationId) console.warn(`CorrelationID: ${correlationId}`);

            let errorMessage: string;
            if (!payload.errorMessage) {
                const responseBody = error.response?.data as any | undefined;
                errorMessage =
                    responseBody?.message ?? 'Произошла непредвиденная ошибка';
            } else {
                errorMessage =
                    typeof payload.errorMessage === 'string'
                        ? payload.errorMessage
                        : payload.errorMessage(error);
            }

            return {
                error: {
                    correlationId,
                    status: error.status ?? 0,
                    message: errorMessage,
                },
            };
        });
};
